const lives = {
    portugues: {
      title: 'Lives',
      subTitle: 'Conheça as mais belas gatas do Bella da Semana. Confira abaixo as últimas modelos:',
      placeHolderSelect: 'Filtrar por nome',
      SeeAllModels: 'Veja todas modelos:',
      seeAllLives: 'Acesse todas as lives',
      livesTitle: 'Lives',
      seeAllLivesPrefix: 'Acesse todas as',
      seeAllLivesHighlight: 'Lives',
      labelPagination: 'de',
      shootModel: 'Veja a live',
      featuredModels: 'Modelos em destaque:',
      lastModels: 'Últimas Modelos',
      models: 'Modelos',
      categories: 'CATEGORIAS',
      nextPage: 'PRÓXIMA PÁGINA',
      prevPage: 'PÁGINA ANTERIOR'
    },
    ingles: {
      title: 'Lives',
      subTitle: 'Meet the most beautiful Bella Club babes. Check out the latest models below:',
      placeHolderSelect: 'Filter by name',
      SeeAllModels: 'See all models:',
      seeAllLives: 'Access all lives',
      livesTitle: 'Lives',
      seeAllLivesPrefix: 'Access all',
      seeAllLivesHighlight: 'Lives',
      labelPagination: 'of',
      shootModel: 'See the live',
      featuredModels: 'Featured Models:',
      lastModels: 'Last Models',
      models: 'Models',
      categories: 'CATEGORIES',
      nextPage: 'NEXT PAGE',
      prevPage: 'PREVIOUS PAGE'
    }
  }
  
  export default lives
  